import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
import { inject, onMounted, ref } from "vue";
import { ResourceServiceSymbol } from "@/InjectionSymbols";
import { validationRules } from "@/ValidationRules";
import { createResourceGroup } from "@/model/ResourceGroup";
import draggable from 'vuedraggable';
import { ResourceType } from "@/model/enum/ResourceType";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditResourceGroupView',
    props: {
        id: { type: Number, required: false },
        resourceType: { type: String, required: false }
    },
    setup(__props) {
        const resourceService = inject(ResourceServiceSymbol);
        const props = __props;
        const editResourceGroup = ref(createResourceGroup(ResourceType.RESOURCE));
        const allResources = ref([]);
        const saveFailed = ref(false);
        const saveInFlight = ref(false);
        const form = ref(null);
        onMounted(() => {
            if (props.id) {
                resourceService?.loadResourceGroup(props.id, resourceGroupLoaded);
            }
            else if (props.resourceType) {
                editResourceGroup.value.resourceType = props.resourceType;
                resourceService?.loadResources(props.resourceType).then(resourcesLoaded);
            }
        });
        function resourcesLoaded(resources) {
            allResources.value = resources;
        }
        function resourceGroupLoaded(resourceGroup) {
            editResourceGroup.value = resourceGroup;
            resourceService?.loadResources(editResourceGroup.value.resourceType).then(resourcesLoaded);
        }
        function save() {
            saveFailed.value = false;
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    saveInFlight.value = true;
                    let promise;
                    if (editResourceGroup.value.id) {
                        promise = resourceService.updateResourceGroup(editResourceGroup.value);
                    }
                    else {
                        promise = resourceService.createResourceGroup(editResourceGroup.value);
                    }
                    promise.then(response => {
                        editResourceGroup.value = response.data;
                        saveInFlight.value = false;
                    }).catch(() => {
                        saveFailed.value = true;
                        saveInFlight.value = false;
                    });
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_form, {
                    ref_key: "form",
                    ref: form
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_container, {
                            fluid: "",
                            class: "d-flex flex-wrap justify-start"
                        }, {
                            default: _withCtx(() => [
                                (!editResourceGroup.value.id)
                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                        key: 0,
                                        class: "ma-0 d-flex justify-start text-h4 v-col-12"
                                    }, {
                                        default: _withCtx(() => [
                                            (editResourceGroup.value.resourceType == _unref(ResourceType).RESOURCE)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode("Neue Resourcengruppe anlegen")
                                                ], 64))
                                                : _createCommentVNode("", true),
                                            (editResourceGroup.value.resourceType == _unref(ResourceType).ATTRIBUTE)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode("Neue Eigenschaftengruppe anlegen ")
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (editResourceGroup.value.id)
                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                        key: 1,
                                        class: "ma-0 d-flex justify-start text-h4 v-col-12"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(editResourceGroup.value.name), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_container, {
                                    class: "d-flex flex-wrap v-col-6",
                                    fluid: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_container, { class: "text-h6 d-flex justify-start" }, {
                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                _createTextVNode("Basis Daten")
                                            ])),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_text_field, {
                                            class: "v-col-2 compact",
                                            modelValue: editResourceGroup.value.id,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editResourceGroup.value.id) = $event)),
                                            label: "ID",
                                            disabled: "",
                                            variant: "outlined"
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_v_text_field, {
                                            class: "v-col-10 compact",
                                            modelValue: editResourceGroup.value.name,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editResourceGroup.value.name) = $event)),
                                            rules: [_unref(validationRules).required],
                                            label: "Name",
                                            variant: "outlined"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_v_select, {
                                            class: "v-col-12 compact",
                                            modelValue: editResourceGroup.value.resources,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((editResourceGroup.value.resources) = $event)),
                                            items: allResources.value,
                                            "item-title": "name",
                                            label: "Resourcen in Gruppe",
                                            multiple: "",
                                            rules: [_unref(validationRules).required],
                                            variant: "outlined",
                                            "return-object": ""
                                        }, null, 8, ["modelValue", "items", "rules"]),
                                        _createVNode(_component_v_container, null, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode(" Drag and Drop zum Sortieren: ")
                                            ])),
                                            _: 1
                                        }),
                                        _createVNode(_unref(draggable), {
                                            modelValue: editResourceGroup.value.resources,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editResourceGroup.value.resources) = $event)),
                                            "item-key": "id"
                                        }, {
                                            [`item`]: _withCtx(({ element }) => [
                                                _createVNode(_component_v_card, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_card_title, null, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(element.name), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1032, ["modelValue"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 512),
                _createVNode(_component_v_btn, { onClick: save }, {
                    default: _withCtx(() => [
                        (!saveInFlight.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Speichern"))
                            : _createCommentVNode("", true),
                        (saveInFlight.value)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 1,
                                indeterminate: true
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (saveFailed.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        class: _normalizeClass({ shake: saveFailed.value }),
                        type: "error",
                        border: "start",
                        rounded: "tl-xl br-xl"
                    }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("Fehler beim Speichern ")
                        ])),
                        _: 1
                    }, 8, ["class"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
